import axios from 'axios';

// api
import {
  getAuthCookie,
  removeAuthCookie,
  getAccessTokenCookie,
  setAccessTokenCookie,
  getRefreshTokenCookie,
  removeAccessTokenCookie,
} from './Storage';

export const HTTP_STATUS = {
  GONE: 410,
  Conflict: 409,
  Forbidden: 403,
  NotFound: 404,
  BadRequest: 400,
  NotAuthorized: 401,
  TooManyRequests: 429,
  ServerInternal: 500,
};

const instance = axios.create({
  baseURL: process.env.REACT_APP_BASE_API_URL,
});

// Request interceptor for API calls
instance.interceptors.request.use(
  async (config) => {
    const keys = getAuthCookie();
    if (config.url.endsWith('signup')) {
      return config;
    }
    if (config.url.startsWith('/customer')) {
      if (
        config.url.endsWith('requestOtp') ||
        config.url.endsWith('submitOtp') ||
        config.url.endsWith('authenticate')
      ) {
        return config;
      }
      let accessToken = getAccessTokenCookie();
      if (!accessToken) {
        try {
          const refreshToken = getRefreshTokenCookie();
          if (!refreshToken) {
            removeAuthCookie();
            removeAccessTokenCookie();
            // eslint-disable-next-line no-restricted-globals
            // location.reload();
            // eslint-disable-next-line no-restricted-globals
            location.href = '/auth/otp';
          }
          const response = await instance.post('/customer/authenticate', {
            refreshToken: refreshToken,
          });

          const newAccessToken = response.data.accessToken;
          setAccessTokenCookie(newAccessToken);
          accessToken = newAccessToken;
        } catch (error) {
          // Handle error when refreshing access token fails
          console.error('Failed to refresh access token:', error);
          console.log('here!');
          // eslint-disable-next-line no-restricted-globals
          location.href = '/auth/otp';

          throw error;
        }
      }
      config.headers = { accesstoken: accessToken };
    } else {
      config.headers = keys?.adminToken
        ? {
            ...(keys && { admintoken: keys.adminToken }),
          }
        : { admintoken: `${getAuthCookie()}` };
    }

    return config;
  },
  (error) => {
    Promise.reject(error);
  }
);

const responseInterceptor = instance.interceptors.response.use(
  (response) => response,
  async (error) => {
    console.log('Errror!');
    if (error?.response?.status === HTTP_STATUS.NotAuthorized) {
      console.log('error', error);
      if (error?.response.config.url.startsWith('/customer')) {
        console.log('ssss');
        removeAccessTokenCookie();
      } else {
        removeAuthCookie();
      }
      // eslint-disable-next-line no-restricted-globals
      location.href = '/auth/otp';
      // eslint-disable-next-line no-restricted-globals
      location.reload();
    }
    // Reject promise if usual error
    instance.interceptors.response.eject(responseInterceptor);

    /*
     * When response code is 401, try to refresh the token.
     * Eject the interceptor so it doesn't loop in case
     * token refresh causes the 401 response
     */
    console.log('sssssssssss');

    return Promise.reject(error);
  }
);

export default instance;
